import expAcademicaApi from "../../api/Alumno/expAcademicaApi";
import { message } from 'antd';

export default {
    getExpAcademicaMe: async() => {
        const response = await expAcademicaApi.getExpAcademicaMe();
        if (!response.success) {
            message.error(response.message);
            response.data = [];
        }
        return response;
    },
    createExpAcademicaMe: async (data) => {
        const response = await expAcademicaApi.createExpAcademicaMe(data);
        if (!response.success) {
            message.error(response.message);
        }
        return response;
    },
    editExpAcademicaMe: async (data) => {
        const response = await expAcademicaApi.editExpAcademicaMe(data);
        if (!response.success) {
            message.error(response.message);
        }
        return response;
    },
    deleteExpAcademicaMe: async (id) => {
        const response = await expAcademicaApi.deleteExpAcademicaMe(id);
        if (!response.success) {
            message.error(response.message);
        }
        return response;
    },
    getCatalogos: async () => {
        const response = await expAcademicaApi.getCatalogos();
        if (!response.success) {
            message.error(response.message);
            response.data = [];
        }
        return response;
    },
}
